export const ContentStateBadgeKind = {
  PIN_LOCK: 'PIN_LOCK',
  GEOBLOCK: 'GEOBLOCK',
} as const
export type ContentStateBadgeKind =
  (typeof ContentStateBadgeKind)[keyof typeof ContentStateBadgeKind]
